import { useEffect, useState } from "react";
import { apiClient } from "@/lib/api";

export default function AdminDiscountRequests() {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    apiClient.get("/admin/discount-requests").then((res) => setRequests(res.data));
  }, []);

  return (
    <div data-testid="admin-discount-requests-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-display font-semibold text-slate-900">First-Time Discount Requests</h1>
        <span className="text-sm text-slate-500" data-testid="admin-discount-requests-count">{requests.length} total</span>
      </div>

      <div className="bg-white border border-slate-200 rounded-md shadow-sm overflow-x-auto">
        <table className="w-full text-sm text-slate-600">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
            <tr>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Phone</th>
              <th className="px-4 py-3">Requested</th>
              <th className="px-4 py-3">Code</th>
              <th className="px-4 py-3">Sent</th>
              <th className="px-4 py-3">Used</th>
              <th className="px-4 py-3">Order</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((r) => (
              <tr key={r.id} className="border-t border-slate-100" data-testid={`admin-discount-request-row-${r.id}`}>
                <td className="px-4 py-3 font-medium text-slate-900">{r.first_name} {r.last_name}</td>
                <td className="px-4 py-3">{r.email}</td>
                <td className="px-4 py-3">{r.phone || "—"}</td>
                <td className="px-4 py-3">{new Date(r.requested_at).toLocaleDateString()}</td>
                <td className="px-4 py-3 font-mono text-xs">{r.code}</td>
                <td className="px-4 py-3">
                  <span className={r.email_sent ? "text-emerald-600 font-semibold" : "text-red-500 font-semibold"}>{r.email_sent ? "Yes" : "No"}</span>
                </td>
                <td className="px-4 py-3">
                  <span className={r.used ? "text-emerald-600 font-semibold" : "text-slate-400"}>{r.used ? "Yes" : "No"}</span>
                </td>
                <td className="px-4 py-3">{r.order_number || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {requests.length === 0 && <p className="p-6 text-center text-slate-400 text-sm" data-testid="admin-no-discount-requests">No discount requests yet.</p>}
      </div>
    </div>
  );
}
